<!--
 * @Author: p_fy
 * @Date: 2019-07-18 17:22:46
 * @LastEditors: pfy
 * @LastEditTime: 2019-09-11 10:13:38
 * @Description: 需求推荐列表，状态：常规推荐、智能推荐。
 -->
<!-- 邀请看仓 -->
<template>
  <div class="transport-news">
    <el-dialog v-dialogDrag :visible.sync="invitationVisible" title="需求推荐" width="80%" @close="$emit('close', false)">
      <div class="demand-head">
        <div class="slider-list">
          <div :class="{ 'selected': !state}" class="item" @click="toggleState(1)">常规推荐</div>
          <div :class="{ 'selected': state}" class="item" @click="toggleState(0)">智能推荐</div>
        </div>
        <!-- 查询表单  -->
        <div v-if="!state && warehousingType == '1'" class="demand-head-form">
          <div class="fileds">
            <el-form ref="form" :model="queryParams" :inline="true" :rules="rule">
              <div class="demand-condition">
                <el-form-item label="租单名称:" prop="demandName">
                  <el-input v-model="queryParams.demandName" placeholder="请输入" />
                </el-form-item>
                <el-form-item label="货物类型:" prop="storageType">
                  <el-select v-model="queryParams.storageType" placeholder="请选择">
                    <el-option v-for="(item,index) in storageType.storageType" :key="index" :label="item.label" :value="item.value" />
                  </el-select>
                </el-form-item>
                <el-form-item label="库房位置:" prop="storageLocation">
                  <el-cascader v-model="queryParams.storageLocation" :options="area" :filterable="true" :props="{ expandTrigger: 'hover' ,
                              checkStrictly: true}"
                    style="width: 100%;" @expand-change="expandChange" />
                </el-form-item>
                <el-form-item label="需求面积:" prop="demandStartArea">
                  <div class="demand-area">
                    <el-row>
                      <el-col :span="11">
                        <el-form-item prop="demandStartArea">
                          <el-input v-model.number="queryParams.demandStartArea" placeholder="请输入" @change="startChange" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="2">
                        <span>至</span>
                      </el-col>
                      <el-col :span="11">
                        <el-form-item prop="demandEndArea">
                          <el-input v-model.number="queryParams.demandEndArea" placeholder="请输入" @change="endChange" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="buttons">
            <el-button size="small" style="background-color: #BE2316;border-color: #F56C6C;" class="form-item-btn" type="primary"
              @click="loadInvitationData">
              <i class="el-icon-search" />查询
            </el-button>
            <el-button size="small" style="background-color: #BE2316;border-color: #F56C6C;" class="form-item-btn" type="primary"
              @click="resetForm">
              <i class="el-icon-delete-solid" />
              重置
            </el-button>
          </div>
        </div>
        <div v-if="!state && warehousingType == '2'" class="demand-head-form">
          <div class="fileds">
            <el-form ref="tankform" :model="tankQueryParams" :inline="true" :rules="rule">
              <div class="demand-condition">
                <el-form-item label="租单名称:" prop="demandName">
                  <el-input v-model="tankQueryParams.demandName" placeholder="请输入" />
                </el-form-item>
                <el-form-item label="货物类型:" prop="storageType">
                  <el-select v-model="tankQueryParams.storageType" placeholder="请选择">
                    <el-option v-for="(item,index) in storageType.storageType" :key="index" :label="item.label" :value="item.value" />
                  </el-select>
                </el-form-item>
                <el-form-item label="需求容积:" prop="goodsStartCubage">
                  <div class="demand-area">
                    <el-row>
                      <el-col :span="11">
                        <el-form-item prop="goodsStartCubage">
                          <el-input v-model="tankQueryParams.goodsStartCubage" placeholder="请输入" @change="tankstartChange" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="2">
                        <span>至</span>
                      </el-col>
                      <el-col :span="11">
                        <el-form-item prop="goodsEndCubage">
                          <el-input v-model="tankQueryParams.goodsEndCubage" placeholder="请输入" @change="tankendChange" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </el-form-item>
                <el-form-item label="库房位置:" prop="storageLocation">
                  <el-cascader v-model="tankQueryParams.storageLocation" :options="area" :filterable="true" :props="{ expandTrigger: 'hover' ,
                              checkStrictly: true}"
                    style="width: 100%;" @expand-change="expandChange" />
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="buttons">
            <el-button size="small" style="background-color: #BE2316;border-color: #F56C6C;" class="form-item-btn" type="primary"
              @click="loadInvitationData">
              <i class="el-icon-search" />查询
            </el-button>
            <el-button size="small" style="background-color: #BE2316;border-color: #F56C6C;" class="form-item-btn" type="primary"
              @click="tankResetForm">
              <i class="el-icon-delete-solid" />
              重置
            </el-button>
          </div>
        </div>
        <div v-loading="viewManager.loading" class="invitation-data">
          <div class="invitation-data-header">
            <ul>
              <li>租单名称</li>
              <li>储存类型</li>
              <li>库房位置</li>
              <li>{{ warehousingType == '2' ? '需求容积' : ' 需求面积' }}</li>
              <li>期望租金</li>
              <li>操作</li>
            </ul>
          </div>
          <div class="invitation-data-body">
            <template v-if="!viewManager.loading && invitationData.length < 1">
              <div class="no-data-info">
                <font>暂无匹配数据</font>
              </div>
            </template>
            <template v-for="(item, index) of invitationData">
              <div :key="index" class="data-item">
                <ul>
                  <el-tooltip class="item" effect="dark" :content="item.demandName" placement="top">
                    <li :title="item.demandName">{{ item.demandName }}</li>
                  </el-tooltip>
                  <el-tooltip v-if="warehousingType == '1' " class="item" effect="dark" :content="item.storageTypeLabel"
                    placement="top">
                    <li :title="item.storageTypeLabel">{{ item.storageTypeLabel }}</li>
                  </el-tooltip>
                  <el-tooltip v-if="warehousingType != '1' " class="item" effect="dark" :content="item.tankTypeLabel"
                    placement="top">
                    <li :title="item.tankTypeLabel">{{ item.tankTypeLabel }}</li>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" :content="item.storageLocationLabel" placement="top">
                    <li :title="item.storageLocationLabel">{{ item.storageLocationLabel }}</li>
                  </el-tooltip>
                  <el-tooltip v-if="warehousingType == '1' " class="item" effect="dark" :content="`${item.demandArea}m²`"
                    placement="top">
                    <li :title="item.demandArea">{{ item.demandArea }}m²</li>
                  </el-tooltip>
                  <el-tooltip v-if="warehousingType != '1' " class="item" effect="dark" :content="`${item.goodsCubage}m³`"
                    placement="top">
                    <li :title="item.goodsCubage">{{ item.goodsCubage }}m³</li>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" :content="`${item.expectPrice}${ warehousingType == '1' ? '元/m²/天' : '元/罐/天' }`"
                    placement="top">
                    <li :title="item.expectPrice">{{ item.expectPrice }}{{ warehousingType == '1' ? '元/m²/天' : '元/罐/天' }}</li>
                  </el-tooltip>
                  <li>
                    <el-button size="mini" type="text" :style="{color:item.collectionStatus == '1' ? '#be2316' : '#409EFF'}"
                      @click="favorites(item)">{{ item.collectionStatus == '1' ?'已收藏':'未收藏' }}</el-button>
                    <el-button v-if="item.inviteUserFlag == '1'" size="mini" type="text" style="color:#be2316;">已邀请</el-button>
                    <el-button v-if="item.inviteUserFlag == '0'" size="mini" type="text" @click="invitation(item)">邀请看仓</el-button>
                    <el-divider direction="vertical" />
                    <el-button plain size="small" @click="demandInfo(item)">
                      详情
                      <i :class="{'expand': !item.hidden}" class="el-icon-d-arrow-right" />
                    </el-button>
                  </li>
                </ul>
                <storeDemandInfo v-if="!item.hidden && warehousingType == '1' " style="position: initial;" :demand="item" />
                <tankDemandInfo v-if="!item.hidden && warehousingType != '1' " style="position: initial;" :demand="item" />
              </div>
            </template>
          </div>
          <div class="invitation-data-pagination">
            <el-pagination :current-page="invitationPagination.pageNo" :total="invitationPagination.total" :page-size="invitationPagination.pageSize"
              layout="prev, pager, next, jumper,total, sizes" @current-change="invitationChangeCurrent" @size-change="invitationChangeSize" />
          </div>
        </div>
      </div>
    </el-dialog>
    <invite-warehousing ref="inviteDialog" :warehousing-type="warehousingType" :invitation-manager="WarehousingInvite.visible"
      :invitation-form="WarehousingInvite.data" @close="WarehousingInvite.close" />
  </div>
</template>
<script>
  // 普仓需求详情
  import storeDemandInfo from '../store-demand-list/components/storeDemandInfo'
  // 罐区需求详情
  import tankDemandInfo from '../tank-demand-list/components/tankDemandInfo'
  import inviteWarehousing from '../../../cloud/components/inviteWarehousing'
  import {
    findPageDemand,
    tankfindPageDemand,
    getArea,
    getDict,
    conllection,
    invitationSave
  } from '@/api/personal/store/demandSuggest'
  import {
    tableClass
  } from '@/api/cloud/storage-demand-info/components/StorageDemandItemsParam' // 仓储供给信息、表单参数列表

  import {
    DatabaseUtil
  } from '@/utils/databaseUtils'
  const dataBase = new DatabaseUtil()
  const table = tableClass.getTable() // 引用表格参数类(包含查询条件的表单)
  export default {
    name: 'InviteWarehousing',
    components: {
      storeDemandInfo,
      tankDemandInfo,
      inviteWarehousing
    },
    props: {
      invitationManager: {
        type: Boolean,
        default: () => false
      },
      invitationForm: {
        type: Object,
        default: () => {}
      },
      warehousingType: {
        type: String,
        default: () => '1'
      }
    },
    data() {
      // 需求面积校验方法
      var validateDemandArea = (rule, value, callback) => {
        if (parseFloat(this.queryParams.demandStartArea) > parseFloat(this.queryParams.demandEndArea)) {
          callback(new Error('请输入最大值'))
        } else {
          callback()
        }
      }
      var validateGoodsArea = (rule, value, callback) => {
        if (parseFloat(this.tankQueryParams.goodsStartCubage) > parseFloat(this.tankQueryParams.goodsEndCubage)) {
          callback(new Error('请输入最大值'))
        } else {
          callback()
        }

      }

      return {
        // 需求面积验证
        rule: {
          demandEndArea: [{
            validator: validateDemandArea,
            trigger: 'blur'
          }],
          goodsEndCubage: [{
            validator: validateGoodsArea,
            trigger: 'blur'
          }]
        },
        invitationVisible: this.invitationManager,
        invitationPagination: table.Page,
        invitationData: [],
        viewManager: {
          loading: true
        },
        WarehousingInvite: {
          visible: false,
          data: {},
          close: () => {
            this.WarehousingInvite.visible = false
          }
        },
        area: [],
        allSelection: false,
        state: false,
        queryParams: {
          demandName: null,
          storageType: null,
          demandStartArea: null,
          demandEndArea: null,
          storageLocation: null,
          publishStatus: '2',
          demandArea: null,
          warehouseType: null
        },
        tankQueryParams: {
          demandName: null,
          storageType: null,
          goodsStartCubage: null,
          goodsEndCubage: null,
          storageLocation: null,
          publishStatus: '2',
          warehouseType: null
        },
        storageType: {
          storageType: [],
          area: []
        },
        typeid: 1

      }
    },
    watch: {
      invitationManager() {
        this.invitationVisible = this.invitationManager
        if (this.invitationVisible) {
          this.loadInvitationData()
        }
      },
      'queryParams.demandStartArea': {
        handler: function(val) {
          var reg = /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/
          if (!this.isEmpty(val) && this.isEmpty(this.queryParams.demandEndArea)) {
            this.queryParams.demandEndArea = ''
          }
          if (!this.isEmpty(val) && (val == 0 || !reg.test(val))) {
            this.queryParams.demandStartArea = ''
          } else {
            if (parseFloat(this.queryParams.demandStartArea) > parseFloat(this.queryParams.demandEndArea)) {
              // this.queryParams.demandEndArea = this.queryParams.demandStartArea
            }
          }
        }
      },
      'queryParams.demandEndArea': {
        handler: function(val) {
          var reg = /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/
          if (!this.isEmpty(val) && this.isEmpty(this.queryParams.demandStartArea)) {
            this.queryParams.demandStartArea = ''
          }
          if (!this.isEmpty(val) && (val == 0 || !reg.test(val))) {
            this.queryParams.demandEndArea = ''
          }
        }
      },
      'tankQueryParams.goodsStartCubage': {
        handler: function(val) {
          var reg = /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/
          if (!this.isEmpty(val) && this.isEmpty(this.tankQueryParams.goodsEndCubage)) {
            this.tankQueryParams.goodsEndCubage = ''
          }
          if (!this.isEmpty(val) && (val == 0 || !reg.test(val))) {
            this.tankQueryParams.goodsStartCubage = ''
          } else {
            if (parseFloat(this.tankQueryParams.goodsStartCubage) > parseFloat(this.tankQueryParams.goodsEndCubage)) {
              // this.tankQueryParams.goodsEndCubage = this.tankQueryParams.goodsStartCubage
            }
          }
        }
      },
      'tankQueryParams.goodsEndCubage': {
        handler: function(val) {
          var reg = /^0{1}([.]\d{1,2})?$|^[1-9]\d*([.]{1}[0-9]{1,2})?$/
          if (!this.isEmpty(val) && this.isEmpty(this.tankQueryParams.goodsStartCubage)) {
            this.tankQueryParams.goodsStartCubage = ''
          }
          if (!this.isEmpty(val) && (val == 0 || !reg.test(val))) {
            this.tankQueryParams.goodsEndCubage = ''
          }
          // if (parseFloat(this.tankQueryParams.goodsStartCubage) > parseFloat(this.tankQueryParams.goodsEndCubage)) {
          //   this.tankQueryParams.goodsStartCubage = this.tankQueryParams.goodsEndCubage
          // }
        }
      },
      'queryParams.demandName': {
        handler: function(val) {
          var reg = this.$character(0, 20, 'regular')
          if (!reg.test(this.queryParams.demandName)) {
            this.queryParams.demandName = ''
          }
        }
      },
      'tankQueryParams.demandName': {
        handler: function(val) {
          var reg = this.$character(0, 20, 'regular')
          if (!reg.test(this.tankQueryParams.demandName)) {
            this.tankQueryParams.demandName = ''
          }
        }
      }
    },
    created() {
      this.getArea()
      this.getStorageType()
    },
    methods: { // 仓库面积范围
      tankstartChange(val) {
        if (!this.isEmpty(this.tankQueryParams.goodsEndCubage) && this.isEmpty(this.tankQueryParams.goodsStartCubage)) {
          // this.tankQueryParams.goodsStartCubage = 1
        }
      },
      // 仓库面积范围
      tankendChange(val) {
        if (!this.isEmpty(this.tankQueryParams.goodsStartCubage) && this.isEmpty(this.tankQueryParams.goodsEndCubage)) {
          // this.tankQueryParams.goodsEndCubage = 1
        }
        if (parseFloat(this.tankQueryParams.goodsStartCubage) > parseFloat(this.tankQueryParams.goodsEndCubage)) {
          // this.tankQueryParams.goodsEndCubage = this.tankQueryParams.goodsStartCubage
        }
      },
      // 仓库面积范围
      startChange(val) {
        if (!this.isEmpty(this.queryParams.demandEndArea) && this.isEmpty(this.queryParams.demandStartArea)) {
          // this.queryParams.demandStartArea = 1
        }
      },
      // 仓库面积范围
      endChange(val) {
        if (!this.isEmpty(this.queryParams.demandStartArea) && this.isEmpty(this.queryParams.demandEndArea)) {
          // this.queryParams.demandEndArea = 1
        }
        if (parseFloat(this.queryParams.demandStartArea) > parseFloat(this.queryParams.demandEndArea)) {
          // this.queryParams.demandEndArea = this.queryParams.demandStartArea
        }
      },
      // 判断字符是否为空的方法
      isEmpty(obj) {
        if (typeof obj == 'undefined' || obj == null || obj == '') {
          return true
        } else {
          return false
        }
      },
      getLocalStorageUtil(name) {
        return new Promise((resolve, reject) => {
          if (dataBase.localStorageUtil.has(name)) {
            resolve(JSON.parse(dataBase.localStorageUtil.get(name)))
          } else {
            reject(name)
          }
        })
      },
      setLocalStorageUtil(name, result) {
        dataBase.localStorageUtil.set(name, JSON.stringify(result))
      },
      // 仓库位置点击事件处理
      expandChange(val) {

        setTimeout(function() {
          var alist = document.getElementsByClassName('el-radio__original')
          if (alist) {
            for (var idx = 0; idx < alist.length; idx++) {
              var mya = alist[idx]
              mya.style.cssText = 'width:160px;height:34px;z-index:1;top:-10px;cursor:inherit'
            }
          }
          console.log('执行了')
        }, 100)
      },
      // 地址字典
      getArea() {
        this.getLocalStorageUtil('area').then((data) => {
          this.area = data
        }).catch(() => {
          getArea()
            .then(data => {
              this.area = data.result
              this.setLocalStorageUtil('area', data.result)
            })
            .catch(error => {
              console.error(error)
            })
        })
      },
      // 储存类型字典
      getStorageType() {
        this.getLocalStorageUtil('storageType').then((storageType) => {
          if (storageType.length > 0) {
            storageType.forEach(res => {
              this.storageType.storageType.push({
                label: res.label,
                value: res.value
              })
            })
          }
        }).catch(() => {
          getDict('storageType').then(res => {
            const storageType = JSON.parse(res.result)
            this.setLocalStorageUtil('storageType', storageType)
            if (storageType.length > 0) {
              storageType.forEach(res => {
                this.storageType.storageType.push({
                  label: res.label,
                  value: res.value
                })
              })
            }
          }).catch(err => {
            console.error(err)
          })
        })
      },
      // 详情展示
      demandInfo(demand) {
        if (demand.hidden) {
          this.invitationData.map(res => {
            res.hidden = true
            return res
          })
        }
        demand.hidden = !demand.hidden
      },
      // 重置表单
      resetForm() {
        this.$refs['form'].resetFields()
        this.queryParams.storageLocation = null
        this.loadInvitationData()
      },
      // 重置罐区表单
      tankResetForm() {
        this.$refs['tankform'].resetFields()
        this.tankQueryParams.storageLocation = null
        this.loadInvitationData()
      },
      // 分页监听
      invitationChangeSize(size) {
        this.invitationPagination.pageSize = size
        this.loadInvitationData()
      },
      // 分页监听
      invitationChangeCurrent(current) {
        this.invitationPagination.pageNo = current
        this.loadInvitationData()
      },
      // 邀请看仓
      invitation(item) {
        // this.WarehousingInvite.data = item
        // this.WarehousingInvite.visible = true
        invitationSave({
          supplyId: this.invitationForm.id,
          demandId: item.id,
          warehousingType: this.warehousingType
        }).then((res) => {
          this.$message({
            offset: 100,
            message: '邀请成功!',
            type: 'success'
          })
          item.inviteUserFlag = '1'
          // item.invithid = false
        }).catch((err) => {
          console.log(err)
        })
      },
      // 收藏
      favorites(item) {
        // 重复点击
        if (item.collectionSubmit) {
          return false
        }
        item.collectionSubmit = true
        const collStatus = item.collectionStatus == '1' ? '2' : '1'
        // 发起收藏?取消收藏的请求
        conllection({
          id: item.collectionId,
          moduleId: item.id,
          moduleType: this.warehousingType == '1' ? '3' : '4',
          collectionStatus: collStatus
        }).then(data => {
          item.collectionStatus = collStatus
          item.collectionId = data.result.id
          this.$message({
            offset: 100,
            message: item.collectionStatus == '1' ? '收藏成功' : '取消收藏成功',
            type: item.collectionStatus == '1' ? 'success' : 'warning'
          })
          item.collectionSubmit = false
        }).catch(error => {
          console.error(error)
          item.collectionSubmit = false
        })
      },
      // 列表查询
      loadInvitationData() {
 console.log(1111111)
        if (parseFloat(this.queryParams.demandStartArea) > parseFloat(this.queryParams.demandEndArea)) {
          return
        } else if (
          parseFloat(this.tankQueryParams.goodsStartCubage) > parseFloat(this.tankQueryParams.goodsEndCubage)
        ) {
          return
        }
        this.viewManager.loading = true
        if (this.warehousingType == '1') {
          // 普仓查询
          const obj = {}
          if (this.state) {
            obj.warehouseType = this.invitationForm.warehouseType
            obj.storageLocation = this.invitationForm.storageLocation
          }

          const params = Object.assign(this.invitationPagination, this.queryParams, obj)
          // console.log(params)
          // if (params.storageLocation != null && params.storageLocation.length > 0) {
          //   params.storageLocation = params.storageLocation.join('#')
          // }

          params.supplyId = this.invitationForm.id
          params.demandArea = this.invitationForm.coveredArea
          params.storageLocation = this.queryParams.storageLocation != null ? this.queryParams.storageLocation.join("#") :
            ''
          findPageDemand(params).then((res) => {
            const invit = []
            res.result.rows.forEach(res => {
              if (res != null) {
                res.hidden = true
                res.selection = false
                res.collectionSubmit = false
                invit.push(res)
              }
            })
            this.invitationPagination.total = res.result.total
            this.invitationData = invit
          }).catch((err) => {
            this.invitationPagination.total = this.invitationData.length
            console.log(err)
          }).finally(() => {
            this.viewManager.loading = false
          })
        } else {
          // 罐区查询
          const obj2 = {}
          if (this.state) {
            obj2.storageType = this.invitationForm.storageType
            obj2.storageLocation = this.invitationForm.storageLocation.toString()
          }
          const params = Object.assign(this.invitationPagination, this.tankQueryParams, obj2)
          // if (params.storageLocation != null && params.storageLocation.length > 0) {
          //   params.storageLocation = params.storageLocation.join('#')
          // }
          params.supplyId = this.invitationForm.id
          params.storageLocation = this.tankQueryParams.storageLocation != null ? this.tankQueryParams.storageLocation.join(
            "#") : ''
          tankfindPageDemand(params).then((res) => {
            const invit = []
            res.result.rows.forEach(res => {
              if (res != null) {
                res.hidden = true
                res.selection = false
                res.collectionSubmit = false
                invit.push(res)
              }
            })
            this.invitationPagination.total = res.result.total
            this.invitationData = invit
          }).catch((err) => {
            this.invitationPagination.total = this.invitationData.length
            console.log(err)
          }).finally(() => {
            this.viewManager.loading = false
          })
        }
      },
      // 多选
      invitationSelSummit() {
        const selData = []
        this.invitationData.forEach(res => {
          if (res.selection) {
            selData.push(res.id)
          }
        })
      },
      // 查询
      invitationFormSummit() {
        console.log("invitationFormSummit")
        this.loadInvitationData()
      },
      toggleState(id) {
        if (id == this.typeid) {
        } else {
          this.typeid = id;
          this.state = !this.state
          this.loadInvitationData()
        }



      }
    }
  }
</script>

<style scoped lang='scss'>
  $main-color: #be2316;

  .transport-news {
    margin-bottom: 1rem;
  }

  /deep/.demand-head {
    padding: 1rem;
    border-style: solid;
    border-width: 0 0 1px 0;
    border-color: #f1f1f1;
    background-color: #ffffff;

    .slider-list {
      display: block;
      margin: 0 0;
      height: 36px;
      overflow: auto;
      white-space: nowrap;
      border-bottom: 1px solid #f1f1f1;

      &::-webkit-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }

      &::-moz-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }

      .item {
        // height: 35px;
        height: calc(100% - 1px);
        display: inline-block;
        width: 100px;
        font-size: 16px;
        font-weight: 600;
        line-height: 35px;
        margin-right: 12px;
        border-bottom: 1px solid rgba(0, 0, 0, 0);
        text-align: center;
        transition: all 1s;
        color: black;
        cursor: pointer;

        &.selected {
          border-bottom: 1px solid $main-color;
          transition: all 1s;
          color: $main-color;
        }
      }
    }

    .demand-head-form {
      padding-top: 1rem;
      display: flex;

      .fileds {
        width: 100%;

        // flex: 0 1 75%;
        /deep/ .el-form-item {
          label:after {
            content: "";
          }
        }

        .demand-condition {
          display: flex;
          flex-wrap: wrap;

          /deep/.el-form-item .el-form-item__content {
            display: flex;
            flex-wrap: wrap;
            width: 217px;

            .demand-area {
              display: inline-flex;
              -webkit-box-align: center;
              -ms-flex-align: center;
              align-items: center;
              padding: 3px 10px;
              -webkit-appearance: none;
              background-color: #FFF;
              background-image: none;
              border-radius: 4px;
              border: 1px solid #DCDFE6;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              color: #606266;
              font-size: inherit;
              height: 40px;
              line-height: 40px;
              outline: 0;
              -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
              transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
              width: 100%;

              /deep/.el-form-item__content {
                width: auto;
              }

              &:focus {
                border-color: #409EFF;
                outline: 0;
              }

              &:hover {
                border-color: #C0C4CC;
              }

              .el-form-item {
                padding-right: 0px;
                width: 100%;
                margin-right: 0 !important;

                /deep/.el-input .el-input__inner {
                  border: 0px solid #DCDFE6;
                  height: 36px;
                  line-height: 36px;
                  text-align: center;
                }
              }
            }
          }

          .el-form-item {
            display: flex;
            -webkit-box-pack: end;
            -ms-flex-pack: end;
            justify-content: flex-end;
            padding-right: 22px;
            width: 50%;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            margin-right: 0 !important;
          }
        }
      }

      .buttons {
        flex: 0 1 35%;
        text-align: center;
        // display: inherit;
        align-items: center;
        justify-content: center;
      }
    }
  }

  /deep/.main-wrap {
    margin-top: 1rem;

    .main {
      width: 1200px;
      margin: 0 auto 1rem;
      border: 1px solid rgba(229, 229, 229, 1);
      box-sizing: border-box;

      .el-form-item {
        padding-left: 20px;
        padding-right: 20px;

        .el-tag {
          margin-right: 1rem;
        }
      }

      .el-form {
        .selected-conditions {
          background-color: #F6F6F6;

          .el-form-item__content {
            display: flex;
            flex-wrap: wrap;

            .el-tag {
              margin-top: auto;
              margin-bottom: auto;
            }
          }

          .clear-conditions {
            cursor: pointer;
            color: #999999;
            align-items: flex-end;
            display: block;
            margin-left: auto;
          }
        }

        .capacity-content {
          .el-form-item__content {
            display: flex;
          }

          .el-input {
            margin-right: 1rem;
            width: 80px;
          }

          .des {
            margin-right: 1rem;
          }

          .el-button-ml {
            background-color: #BE2316;
            color: #ffffff;
          }
        }

        /*复选组样式 start*/
        .el-checkbox-button {
          margin-right: 1rem;
        }

        .el-checkbox-button:first-child .el-checkbox-button__inner {
          border-radius: 0 !important;
        }

        .el-checkbox-button:last-child .el-checkbox-button__inner {
          border-radius: 0 !important;
        }

        .el-checkbox-button.is-checked .el-checkbox-button__inner {
          background-color: #BE2316;
          border-color: #BE2316;
          color: #ffffff;
          box-shadow: -1px 0 0 0 #BE2316;
        }

        .el-checkbox-button__inner:hover {
          color: #BE2316;
        }

        .el-checkbox-button .el-checkbox-button__inner {
          border: none !important;
        }

        .el-checkbox-button.is-checked:first-child .el-checkbox-button__inner {
          border-left-color: #BE2316
        }

        /*复选组样式 end*/
        /*单选组样式 start*/
        .el-radio-button {
          margin-right: 1rem;
        }

        .el-radio-button:first-child .el-radio-button__inner {
          border-radius: 0 !important;
        }

        .el-radio-button:last-child .el-radio-button__inner {
          border-radius: 0 !important;
        }

        .el-radio-button__orig-radio:checked+.el-radio-button__inner {
          background-color: #BE2316;
          border-color: #BE2316;
          color: #ffffff;
          box-shadow: -1px 0 0 0 #BE2316;
        }

        .el-radio-button__inner:hover {
          color: #BE2316;
        }

        .el-radio-button .el-radio-button__inner {
          border: none !important;
        }

        .el-radio-button.is-checked:first-child .el-radio-button__inner {
          border-left-color: #BE2316
        }

        /*单选组样式 end*/
        .transport-data {
          display: flex;

          .el-input {
            margin-right: 1rem;
          }

          .des {
            margin-right: 1rem;
          }
        }

        .form-item {
          margin-right: 0;

          .form-item-btn {
            background: #BE2316;
            border: none;

            i {
              font-size: 14px;
              padding-right: 10px;
            }
          }
        }
      }
    }

    .content {
      position: relative;
      width: 1200px;
      margin: 0 auto;
      margin-bottom: 50px;

      .content-img {
        width: 1200px;
      }

      .content-shoucang-tc {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -85px;
        margin-top: -35px;
      }

      .content-baojia {
        position: absolute;
        width: 50px;
        height: 100%;
        right: 0;
        top: 0;
      }

      .content-shoucang {
        position: absolute;
        width: 50px;
        height: 100%;
        right: 50px;
        top: 0;
      }

    }

    /*表格相关*/
    .table-wrap {
      width: 1200px;
      margin: 0 auto;
    }
  }

  .invitation-data {

    .invitation-form {
      .condition-group {
        margin-top: 0.5rem;
        padding-left: 8px;
      }
    }

    .invitation-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 45px;
      margin-bottom: 1rem;

      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 100%;
        width: calc(100% - 16px);
        padding: 8px 8px;
        box-sizing: content-box;

        li {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 29px;
          padding: 5px 0.4%;
          text-align: center;

          &:nth-child(1) {
            flex-basis: 16.6%;
          }

          &:nth-child(2) {
            flex-basis: 16.6%;
          }

          &:nth-child(3) {
            flex-basis: 16.6%;
          }

          &:nth-child(4) {
            flex-basis: 14.1%;
          }

          &:nth-child(5) {
            flex-basis: 14.1%;
          }

          &:nth-child(6) {
            flex-basis: 18%;
            padding: 0;
          }
        }
      }
    }

    .invitation-data-body {
      position: relative;

      .no-data-info {
        background-color: #fff;
        width: 100%;
        text-align: center;
        margin-top: 8px;
        height: 48px;
        line-height: 48px;
        font-size: 15px;
      }

      .data-item {
        margin: 8px 0px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border: 1px solid #ebeef5;
        position: relative;

        ul {
          display: flex;
          flex-wrap: nowrap;
          height: 56px;
          width: calc(100% - 16px);
          padding: 8px 8px;
          position: relative;
          background-color: white;

          li {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 15px;
            min-width: 50px;
            height: 100%;
            padding: 5px 0.4%;
            line-height: 55px;
            text-align: center;

            &:nth-child(1) {
              flex-basis: 16.6%;
            }

            &:nth-child(2) {
              flex-basis: 16.6%;
            }

            &:nth-child(3) {
              flex-basis: 16.6%;
            }

            &:nth-child(4) {
              flex-basis: 14.1%;
            }

            &:nth-child(5) {
              flex-basis: 14.1%;
            }

            &:nth-child(6) {
              flex-basis: 18%;
              overflow: initial;
              padding: 0;
              white-space: initial;
            }

            /deep/ .el-button.is-plain {
              background-color: white;
              color: #be2316;
              border-color: #be2316;
              padding: 7px 4px !important;
              width: 56px;

              span>i {
                transition: 1s all;
                transform: rotateZ(90deg);

                &.expand {
                  transform: rotateZ(-90deg);
                }
              }
            }
          }
        }

        /deep/ .goods-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }

    .invitation-data-pagination {
      width: calc(100% - 32px);
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
    }
  }
</style>
